import {
  toCurrency,
  toNumber,
  toPercentage,
  getSortedDates,
} from './format.util';

export function getIndexData(index, zoom = null) {
  const stats = [];
  const indexStats = [];

  let dailySalesTotal = {};
  let dailyIndexTotal = {};

  if (index && index.dailySalesTotal) {
    dailySalesTotal = { label: 'Daily Sales Total', data: index.dailySalesTotal };

    const salesTimelineData = getTimelineData(index.dailySalesTotal, zoom);

    stats.push({
      label: 'Low Daily Volume',
      value: toCurrency(salesTimelineData.lowValue),
    });

    stats.push({
      label: 'High Daily Volume',
      value: toCurrency(salesTimelineData.highValue),
    });

    stats.push({
      label: 'Average Daily Volume',
      value: toCurrency(salesTimelineData.averageValue),
    });
  }

  if (index && index.dailyIndexTotal) {
    dailyIndexTotal = { label: 'Daily Index Total', data: index.dailyIndexTotal };

    const indexTimelineData = getTimelineData(index.dailyIndexTotal, zoom);

    if (indexTimelineData.hasData) {
      indexStats.push({
        label: 'Starting Value',
        value: toNumber(indexTimelineData.startValue),
      });

      indexStats.push({
        label: 'Current Value',
        value: toNumber(indexTimelineData.currentValue),
      });

      indexStats.push({
        label: 'Rate of Growth',
        value: `${indexTimelineData.percentChange > 0 ? '+' : ''}${toPercentage(indexTimelineData.percentChange)}`,
        negative: indexTimelineData.percentChange < 0,
        positive: indexTimelineData.percentChange > 0,
      });

      indexStats.push({
        label: 'Real Value Change',
        value: `${indexTimelineData.valueChange > 0 ? '+' : ''}${toNumber(indexTimelineData.valueChange)}`,
        negative: indexTimelineData.valueChange < 0,
        positive: indexTimelineData.valueChange > 0,
      });

      indexStats.push({
        label: 'Low Value',
        value: toNumber(indexTimelineData.lowValue),
      });

      indexStats.push({
        label: 'High Value',
        value: toNumber(indexTimelineData.highValue),
      });

      indexStats.push({
        label: 'Average Value',
        value: toNumber(indexTimelineData.averageValue),
      });
    }
  }

  if (index) {
    if (index.totalCards) {
      indexStats.push({
        label: 'Total Cards',
        value: toNumber(index.totalCards),
      });
    }

    if (typeof index.dailySalesCount === 'number') {
      stats.push({
        label: '# of Sales 24H',
        value: toNumber(index.dailySalesCount),
      });
    }

    if (index.totalMarketCap) {
      stats.push({
        label: 'Market Cap',
        value: toCurrency(index.totalMarketCap),
      });
    }
  }

  return {
    stats,
    indexStats,
    dailySalesTotal,
    dailyIndexTotal,
  };
}

function getTimelineData(dailySales, zoom) {
  const timelineData = [];
  const sortedDates = getSortedDates(dailySales, zoom);

  sortedDates.forEach((d) => {
    timelineData.push({ date: d, value: dailySales[d] });
  });

  const startValue = timelineData.length > 0 ? timelineData[0].value : 0;
  const currentValue = timelineData.length > 0 ? timelineData[timelineData.length - 1].value : 0;

  return {
    hasData: timelineData.length > 0,
    startValue,
    currentValue,
    highValue: Math.max(...timelineData.map((data) => data.value)),
    lowValue: Math.min(...timelineData.map((data) => data.value)),
    averageValue: timelineData.length ? (timelineData.reduce((total, point) => total + point.value, 0)) / timelineData.length : 0,
    percentChange: timelineData.length < 2 || startValue === 0 ? 0 : (currentValue - startValue) / startValue,
    valueChange: timelineData.length < 2 ? 0 : currentValue - startValue,
  };
}
